import {
  type BinaryChoiceElicitation,
  isBinaryChoiceElicitation,
  type RenderableElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

/** `UnknownElicitation.type` is `string`, so equality alone won't narrow the union in JSX. */
export const isBinaryChoiceElicitationEntry = (
  elicitation: RenderableElicitation | null,
): elicitation is BinaryChoiceElicitation => elicitation !== null && isBinaryChoiceElicitation(elicitation);
